import { render, staticRenderFns } from "./downLoad.vue?vue&type=template&id=d57f44fe&scoped=true"
import script from "./downLoad.vue?vue&type=script&lang=js"
export * from "./downLoad.vue?vue&type=script&lang=js"
import style0 from "./downLoad.vue?vue&type=style&index=0&id=d57f44fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57f44fe",
  null
  
)

export default component.exports